export const BACKGROUND = '#EFF1F3';
export const BACKGROUND_SECONDARY = '#DBD3D8';

export const PRIMARY = '#223843';
export const SECONDARY = '#D77A61';
export const TERTIARY = '#D8B4A0';

export const WHITE = '#fefefe';
export const BLACK = '#000';
